import meetingsService from '../services/meetingsService';

export const createMeeting = async (payload) => {
  const result = await meetingsService.createMeeting(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplantı oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createMeetingWithGallery = async ({ dto, galleryImages }) => {
  const result = await meetingsService.createMeetingWithGallery({ dto, galleryImages });
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplantı oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateMeeting = async (payload) => {
  const result = await meetingsService.updateMeeting(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplantı güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchMeetingById = async (id) => {
  const result = await meetingsService.getMeetingById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplantı bulunamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchAllMeetings = async ({
  pageNumber = 1,
  pageSize = 10,
  startDate = null,
  endDate = null,
  isActive = null,
  searchTerm = null,
} = {}) => {
  const result = await meetingsService.getAllMeetings({
    pageNumber,
    pageSize,
    startDate,
    endDate,
    isActive,
    searchTerm,
  });
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplantılar alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const searchMeetingsByDateRange = async ({
  startDate,
  endDate,
  pageNumber = 1,
  pageSize = 10,
  isActive = null,
} = {}) => {
  const result = await meetingsService.searchMeetingsByDateRange({
    startDate,
    endDate,
    pageNumber,
    pageSize,
    isActive,
  });
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplantılar aranırken hata oluştu');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const deleteMeeting = async (id) => {
  const result = await meetingsService.deleteMeeting(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplantı silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const toggleMeetingActiveStatus = async (id) => {
  const result = await meetingsService.toggleMeetingActiveStatus(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Toplantı durumu değiştirilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Meeting Attendance
export const createMeetingAttendance = async (payload) => {
  const result = await meetingsService.createMeetingAttendance(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı eklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const registerMeetingAttendance = async (payload) => {
  const result = await meetingsService.registerMeetingAttendance(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Kayıt yapılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const unregisterMeetingAttendance = async (payload) => {
  const result = await meetingsService.unregisterMeetingAttendance(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Kayıt iptal edilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchMeetingAttendanceFullList = async (meetingId) => {
  const result = await meetingsService.getMeetingAttendanceFullList(meetingId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcılar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchMeetingAttendances = async (meetingId, filters = {}) => {
  const result = await meetingsService.getMeetingAttendances(meetingId, filters);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcılar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchMeetingAttendanceDetail = async (meetingId, attendanceId) => {
  const result = await meetingsService.getMeetingAttendanceDetail(meetingId, attendanceId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı detayı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchMeetingAttendanceSummary = async (meetingId) => {
  const result = await meetingsService.getMeetingAttendanceSummary(meetingId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Özet bilgiler alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateMeetingAttendanceStatus = async (payload) => {
  const result = await meetingsService.updateMeetingAttendanceStatus(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı durumu güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const setMeetingAttendanceExempt = async (payload) => {
  const result = await meetingsService.setMeetingAttendanceExempt(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'İzin durumu güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateMeetingGuestStatus = async (payload) => {
  const result = await meetingsService.updateMeetingGuestStatus(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Misafir durumu güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const removeMeetingAttendance = async (meetingId, attendanceId) => {
  const result = await meetingsService.removeMeetingAttendance(meetingId, attendanceId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const removeMeetingGuest = async (meetingId, guestId) => {
  const result = await meetingsService.removeMeetingGuest(meetingId, guestId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Misafir silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const generateMeetingAttendanceReport = async (meetingId) => {
  const result = await meetingsService.generateMeetingAttendanceReport(meetingId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Rapor oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const checkMeetingReportExists = async (meetingId) => {
  const result = await meetingsService.checkMeetingReportExists(meetingId);
  if (!result?.success) {
    return false;
  }
  return result.data === true;
};

export const fetchMeetingAttendanceReport = async (meetingId) => {
  const result = await meetingsService.getMeetingAttendanceReport(meetingId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Rapor alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const syncAllMeetingMembers = async (meetingId) => {
  const result = await meetingsService.syncAllMeetingMembers(meetingId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Üyeler senkronize edilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const downloadMeetingAttendanceReportExcel = async (meetingId) => {
  // Bu endpoint File döndürdüğü için ServiceResponse sarmalı yok, direkt blob alıyoruz.
  return meetingsService.downloadMeetingAttendanceReportExcel(meetingId);
};

export const fetchMemberAttendanceSummaries = async (params = {}) => {
  const result = await meetingsService.getMemberAttendanceSummaries(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Üye katılım özetleri alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchMemberAttendanceSummaryByMember = async (params = {}) => {
  const result = await meetingsService.getMemberAttendanceSummaryByMember(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Üye toplantı katılım özeti alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchWeeklyMeetingConfig = async () => {
  const result = await meetingsService.getWeeklyMeetingConfig();
  if (!result?.success) {
    const error = new Error(result?.message || 'Yemek birim fiyatı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateWeeklyMeetingConfig = async (payload) => {
  const result = await meetingsService.updateWeeklyMeetingConfig(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Yemek birim fiyatı güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  createMeeting,
  updateMeeting,
  fetchMeetingById,
  fetchWeeklyMeetingConfig,
  updateWeeklyMeetingConfig,
  fetchAllMeetings,
  searchMeetingsByDateRange,
  deleteMeeting,
  toggleMeetingActiveStatus,
  createMeetingAttendance,
  registerMeetingAttendance,
  unregisterMeetingAttendance,
  fetchMeetingAttendanceFullList,
  fetchMeetingAttendances,
  fetchMeetingAttendanceDetail,
  fetchMeetingAttendanceSummary,
  updateMeetingAttendanceStatus,
  setMeetingAttendanceExempt,
  updateMeetingGuestStatus,
  removeMeetingAttendance,
  removeMeetingGuest,
  generateMeetingAttendanceReport,
  checkMeetingReportExists,
  fetchMeetingAttendanceReport,
  syncAllMeetingMembers,
  downloadMeetingAttendanceReportExcel,
  fetchMemberAttendanceSummaries,
  fetchMemberAttendanceSummaryByMember,
};
